import { render } from "./verify-user.vue?vue&type=template&id=0c2956f6"
import script from "./verify-user.vue?vue&type=script&lang=js"
export * from "./verify-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__